import React from 'react';

export default () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 7.6875H6.75V18H3V7.6875ZM14.25 11.4375H18V18H14.25V11.4375ZM8.625 3H12.375V18H8.625V3Z" fill="currentColor" />
  </svg>

);
